import * as React from "react";
import { memo } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIdAustriaKey = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "150 0 580 580",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#5F7A8E",
			d: "M607.9 285.1c-7.8 0-14.8-3-20.8-9s-9-12.9-9-20.8c0-7.8 2.9-14.6 8.6-20.4 5.8-5.7 12.8-8.6 21.2-8.6s15.3 2.8 20.8 8.2c5.5 5.5 8.2 12.4 8.2 20.8s-2.9 15.4-8.6 21.2c-5.8 5.7-12.6 8.6-20.4 8.6"
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "a",
			x1: 544.715,
			x2: 544.715,
			y1: 405.86,
			y2: 150.92,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				offset: 0,
				stopColor: "#8BA3BE"
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#466272"
			})]
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "url(#a)",
			d: "M713.8 208.2v140.4c-.3 16.1-6 29.5-16.9 40.4-11.2 11.2-25.2 16.9-42 16.9H498.8c-4.2 0-8.2-1.2-12.2-3.5q-5.85-3.6-9-9l-42.4-73.7h-59.6v-35.3h65.9c4.2 0 8.2 1.1 12.2 3.1 3.9 2.1 6.9 5 9 8.6l43.2 74.5h142.8c8.4 0 15.4-2.9 21.2-8.6 5.8-5.8 8.6-12.8 8.6-21.2V216c0-8.4-2.9-15.4-8.6-21.2-5.8-5.8-12.8-8.6-21.2-8.6H505.1l-24.3 42.4c-2.1 3.7-5.1 6.5-9 8.6s-8 3.1-12.2 3.1h-83.9V205h77.7l24.3-42.4c2.1-3.7 5.1-6.5 9-8.6s8-3.1 12.2-3.1H655c16.7 0 30.7 5.6 42 16.9 10.8 10.9 16.4 24.4 16.8 40.4"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#E6320F",
			d: "m160.7 203.5 18.8 39.2h156.9v-39.2zM336.4 321.1v-39.2h-138l18.8 39.2z"
		})
	]
});
const Memo = memo(SvgIdAustriaKey);
export default Memo;
